import React from "react";

function Time(){
    return(
        <div>
        <h1>ERROR PAGE NOT FOUND</h1>
        <p> Contact Admin for more</p>
        </div>
    )
        
    
}
export default Time;